import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import I18n from 'i18n-js';
import React from 'react';

export const HomepageWelcome = () => {
  const user = useUser();
  const userName = (user.name || '').split(' ').at(0);
  const i18nKey = userName.length > 0 ? 'welcomeHeadingWithUserName' : 'welcomeHeadingWithoutUserName';

  return <>
    <div className="scaling-mt-4">
      <div className="homepage-heading__left">
        <div className="homepage-heading__inner">
          <h2 className="homepage-heading__title">{I18n.t(`discovery.homepage.${i18nKey}`, { userName })}</h2>
        </div>
      </div>
    </div>
  </>;
};
